module.exports = __webpack_public_path__ + "static/media/mikekunz.98296e8c.jpg";